const IS_LOCAL = window.location.href.indexOf('localhost') !== -1;
console.log(IS_LOCAL ? "running in localhost": "running remotely");
const BACKEND_URL = IS_LOCAL ? "http://localhost:8080": "https://imagine-story-docker.onrender.com";

const AUTH_DOMAIN= "dev-wyt5smthu3q6o547.eu.auth0.com"
const AUTH_CLIENT_ID= "T2kBiDsH91N1l3vlZtBqj6YXTea72BZL"

export { BACKEND_URL, AUTH_CLIENT_ID, AUTH_DOMAIN};
